import { Fragment, useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Components
import Alert from './components/layout/Alert';
import Layout from './components/layout/Layout';
import PrivateRoute from './components/routing/PrivateRoute';
import ValidateSession from './components/routing/ValidateSession';
import NoMatch from './components/routing/NoMatch';

// Login
import Login from './views/auth/Login';

// Eliminacion
import Eliminacion from './views/auth/Eliminacion';

// Desuscripcion
import Desuscripcion from './views/auth/Desuscripcion';
import DesuscripcionApp from './views/auth/DesuscripcionApp';

// Privacidad
import Privacidad from './views/auth/Privacidad';

// Dashboard
import Dashboard from './views/dashboard/Dashboard';

// Locatarios
import Locatarios from './views/locatarios/Locatarios';
import NuevoLocatario from './views/locatarios/NuevoLocatario';
import EditarLocatario from './views/locatarios/EditarLocatario';
import DetallesLocatario from './views/locatarios/DetallesLocatario';
import UsuariosLocatario from './views/locatarios/UsuariosLocatario';

// Clientes
import Clientes from './views/clientes/Clientes';
import NuevoCliente from './views/clientes/NuevoCliente';
import EditarCliente from './views/clientes/EditarCliente';
import DetallesCliente from './views/clientes/DetallesCliente';

// Usuarios
import Usuarios from './views/usuarios/Usuarios';
import NuevoUsuario from './views/usuarios/NuevoUsuario';
import EditarUsuario from './views/usuarios/EditarUsuario';

// Citas
import CitasCalendario from './views/citas/CitasCalendario';
import CitasListado from './views/citas/CitasListado';

// Reportes
import Reportes from './views/reportes/Reportes';

// Configuración
import Servicios from './views/configuracion/servicios/Servicios';
import Membresias from './views/configuracion/membresias/Membresias';
import Paquetes from './views/configuracion/paquetes/Paquetes';
import Perfil from './views/configuracion/perfil/Perfil';

// Redux
import store from './store';
import { loadUser } from './actions/auth';
import setAuthToken from './utils/setAuthToken';

function App() {
	if (localStorage.token) {
		setAuthToken(localStorage.token);
	}

	useEffect(() => {
		store.dispatch(loadUser());
	}, []);

	return (
		<Provider store={store}>
			<BrowserRouter>
				<Fragment>
					<Layout></Layout>
					<section className="container-fluid principal-section">
						<Alert></Alert>

						<Routes>
							{/* Login */}
							<Route exact path="/" element={<ValidateSession><Login /></ValidateSession>}/>
							<Route exact path="/login" element={<ValidateSession><Login /></ValidateSession>}/>

							{/* Eliminacion */}
							<Route exact path="/eliminacion" element={<ValidateSession><Eliminacion /></ValidateSession>}/>

							{/* Desuscripcion */}
							<Route exact path="/desuscripcion/:id" element={<ValidateSession><Desuscripcion /></ValidateSession>}/>
							<Route exact path="/desuscripcion_app/:id" element={<ValidateSession><DesuscripcionApp /></ValidateSession>}/>

							{/* Privacidad */}
							<Route exact path="/privacidad" element={<ValidateSession><Privacidad /></ValidateSession>}/>

							{/* Dashboard */}
							<Route path="/dashboard" element={<PrivateRoute routePermission=''><Dashboard /></PrivateRoute>}/>

							{/* Clientes */}
							<Route path="/clientes" element={<PrivateRoute routePermission='clientes.ver'><Clientes /></PrivateRoute>}/>
							<Route path="/clientes/nuevo" element={<PrivateRoute routePermission='clientes.agregar'><NuevoCliente /></PrivateRoute>}/>
							<Route path="/clientes/editar/:id" element={<PrivateRoute routePermission='clientes.editar'><EditarCliente /></PrivateRoute>}/>
							<Route path="/clientes/detalles/:id" element={<PrivateRoute routePermission='clientes.detalles'><DetallesCliente /></PrivateRoute>}/>

							{/* Locatarios */}
							<Route path="/locatarios" element={<PrivateRoute routePermission='locatarios.ver'><Locatarios /></PrivateRoute>}/>
							<Route path="/locatarios/nuevo" element={<PrivateRoute routePermission='locatarios.agregar'><NuevoLocatario /></PrivateRoute>}/>
							<Route path="/locatarios/editar/:id" element={<PrivateRoute routePermission='locatarios.editar'><EditarLocatario /></PrivateRoute>}/>
							<Route path="/locatarios/detalles/:id" element={<PrivateRoute routePermission='locatarios.detalles'><DetallesLocatario /></PrivateRoute>}/>
							<Route path="/locatarios/usuarios/:id" element={<PrivateRoute routePermission='locatarios.usuarios.ver'><UsuariosLocatario /></PrivateRoute>}/>

							{/* Usuarios */}
							<Route path="/usuarios" element={<PrivateRoute routePermission='usuarios.ver'><Usuarios /></PrivateRoute>}/>
							<Route path="/usuarios/nuevo" element={<PrivateRoute routePermission='usuarios.agregar'><NuevoUsuario /></PrivateRoute>}/>
							<Route path="/usuarios/editar/:id" element={<PrivateRoute routePermission='usuarios.editar'><EditarUsuario /></PrivateRoute>}/>

							{/* Citas */}
							<Route path="/citas/calendario" element={<PrivateRoute routePermission='citas.ver'><CitasCalendario /></PrivateRoute>}/>
							<Route path="/citas/agenda" element={<PrivateRoute routePermission='citas.ver'><CitasListado /></PrivateRoute>}/>

							{/* Reportes */}
							<Route path="/reportes" element={<PrivateRoute><Reportes /></PrivateRoute>}/>

							{/* Configuración */}
							<Route path="/configuracion/servicios" element={<PrivateRoute routePermission='configuracion.servicios.ver'><Servicios /></PrivateRoute>}/>
							<Route path="/configuracion/membresias" element={<PrivateRoute routePermission='configuracion.membresias.ver'><Membresias /></PrivateRoute>}/>
							<Route path="/configuracion/paquetes" element={<PrivateRoute routePermission='configuracion.paquetes.ver'><Paquetes /></PrivateRoute>}/>
							<Route path="/configuracion/perfil" element={<PrivateRoute routePermission='configuracion.perfil.ver'><Perfil /></PrivateRoute>}/>
							
							{/* Cuando no matchea con nada*/}
							<Route path="*" element={<NoMatch />}/>
						</Routes>
					</section>
				</Fragment>
			</BrowserRouter>
		</Provider>
	);
}

export default App;